<template>
<div>
	<b-row v-if="slots.length > 1">
		<b-col>
			<div class="slot-container">
				<ul v-if="slots && !admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[0][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[0]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="setClass(slot.status, slot.slot_time, slot.slotDate)">{{ slot.slot_time}}<br />{{ setClass(slot.status, slot.slot_time, slot.slotDate)}}</div></li>
				</ul>
				<ul v-if="slots && admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[0][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[0]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ setClass(slot.status, slot.slot_time, slot.slotDate)}}</div></li>
				</ul>
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[0][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[0]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[1][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[1]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[1][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[1]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>				
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[1][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[1]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[2][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[2]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[2][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[2]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[2][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[2]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[3][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[3]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[3][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[3]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[3][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[3]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[4][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[4]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[4][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[4]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>				
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[4][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[4]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate, slot.booked , slot.value), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[5][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[5]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[5][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[5]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[5][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[5]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul v-if="!admin">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[6][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[6]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="slot.status">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="admin && !dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[6][0].slotDate | moment("ddd D MMM") }}</div></li>
				<li v-for="slot in slots[6]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" v-b-popover.hover.top="slot.booked + ' x confirmed orders'" :title="slot.slot_time + '   (' + slot.value +' slots)'" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.status}}</div></li>
				</ul>
				<ul v-if="slots && admin && dataView">
				<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ slots[6][0].slotDate | moment("ddd D MMM")  }}</div></li>
				<li v-for="slot in slots[6]" :key="slot.id" @click="showParentModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, slot.status, slot.time_status)"><div class="border p-3" :class="[setClass(slot.status, slot.slot_time, slot.slotDate), slot.time_status]">{{ slot.slot_time}}<br />{{ slot.booked + ' of ' + slot.value + ' booked' }}</div></li>
				</ul>
			</div>
		</b-col>
	</b-row>
</div>
</template>

<script>
import {mixin} from '../mixins/clickAndCollectMixins'

export default{
	name: 'WeekSlotsGrid',
	props: ['slots', 'admin', 'dataView'],
	mixins: [mixin],
	data(){
		return{
	
			}
	},
	created()
	{
	console.log(this.slots)
	},
	methods: {	
		showParentModal(slotId, slotDate, slotDay, slotTime, slotType, slotStatus, slotTimeStatus){
		if(slotStatus == "Available" && slotTimeStatus == "Enabled")
		{
			this.$emit("show-form-modal", {slotId, slotDate, slotDay, slotTime, slotType})
		}
		}
	},
	computed:{
	}
}
</script>

<style scoped>
.col {
    padding: 0px
}
.slotColHeaderInner{
font-weight: bold;
}
li{
font-size: 0.6em;
line-height: 1.2;
}

.p-3 {
 padding: .5rem !important; 
}

.Available{
color: #000000;
background-color: #69d081
}

.Unavailable, .Same-Day.Enabled, .Same-Day.closed{
color: #000000;
background-color: #f9465a;
}

.Unavailable.closed{
color: #000000;
background-color: #c0c0c0;
}

.Unavailable.Enabled{
color: #000000;
background-color: orange;
}

ul{
padding-inline-start: 0px;
}
li{
list-style-type:none
}

div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}
</style>
